var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#FFE2B6",
    fillOpacity: 0.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F7BA78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 27C21.4477 27 21 27.4477 21 28C21 28.5523 21.4477 29 22 29V27ZM34.7071 28.7071C35.0976 28.3166 35.0976 27.6834 34.7071 27.2929L28.3431 20.9289C27.9526 20.5384 27.3195 20.5384 26.9289 20.9289C26.5384 21.3195 26.5384 21.9526 26.9289 22.3431L32.5858 28L26.9289 33.6569C26.5384 34.0474 26.5384 34.6805 26.9289 35.0711C27.3195 35.4616 27.9526 35.4616 28.3431 35.0711L34.7071 28.7071ZM22 28V29H34V28V27H22V28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepArrow);
export default __webpack_public_path__ + "static/media/stepArrow.c59b5f51bd5960d8bdabfadd8f20aacb.svg";
export { ForwardRef as ReactComponent };